// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"KnowledgeBase_headerWrapper__2yFyq","title":"KnowledgeBase_title__3HQ3m","content":"KnowledgeBase_content__2XAxL"};